<template>
  <div>
    <BaseTitle :title="$t('content.list_student')" />
    <v-card class="pa-8 d-flex justify-space-between">
      <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
      <div>
        <div class="app-section-title mb-5">
          {{ form.integrationName }}
          <br />
        </div>
        <span class="mt-6">
          {{ $t('table.school_name') }} :
          <strong class="ml-2" style="color: #6d6d6d;"> {{ form.schoolName }}</strong>
        </span>
        <span class="ml-6 mr-6"> | </span>
        <span class="mt-6">
          {{ $t('content.name_teacher') }} :
          <strong class="ml-2" style="color: #6d6d6d;"> {{ form.fullName }}</strong>
        </span>
      </div>
      <v-btn
        color="primary"
        class="btn-primary-custom mt-5 mb-md-0 mr-md-2"
        v-if="listStudent.length && form.editable"
        :loading="loadingPublish"
        @click="publishExport"
      >
        {{ !published ? $t('content.publish_erapor') : $t('content.unpublish_erapor') }}
      </v-btn>
      <v-btn color="primary" @click="clickGenerate" class="btn-primary-custom mt-5 mb-md-0 mr-md-2">{{ $t('content.generate') }}</v-btn>
    </v-card>
    <v-card>
      <div>
        <div class="ml-5 mt-8 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-text-field v-model="search" :label="$t('search')" clearable @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <template v-if="listStudent.length">
          <div v-for="(item, index) in listStudent" :key="index" class="border-item">
            <v-row class="border-item">
              <v-col md="1" align="center">
                <div class="mt-5 ml-5">
                  <svg-icon icon="ic_erapor" width="35" height="35" class="primary--text" />
                  <v-divider vertical></v-divider>
                </div>
              </v-col>
              <v-col md="10" class="mt-3">
                <div class="d-block">
                  <h3 class="d-inline">
                    <span class="header-content">{{ item.fullName }} </span>
                  </h3>
                </div>
                <div class="d-block">
                  <div>
                    <span class="body-content">
                      <span class="mr-3">
                        NIS :
                        <strong>{{ item.identityNumber }}</strong>
                      </span>
                      |
                      <span class="mr-3">
                        {{ $t('table.gender') }} :
                        <strong v-if="item.gender">{{ $t('form.' + item.gender.toLowerCase()) }}</strong>
                        <strong v-else>-</strong>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="d-flex"></div>
              </v-col>
              <v-col md="1">
                <template>
                  <div class="pa-5">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span dark v-bind="attrs" v-on="on">
                          <svg-icon icon="ic-moreaction-black" class="mt-1" />
                        </span>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-list-item-title class="text-dropdown" @click="viewItem(item.studentId)">{{ $t('view') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="form.editable">
                          <v-list-item-title class="text-dropdown" @click="editItem(item.studentId)">{{ $t('edit') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title class="text-dropdown" @click="getExport(item.studentId, item)">{{
                            $t('content.print')
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </v-col>
            </v-row>
          </div>
        </template>
        <NoData class="mt-16" v-if="!listStudent.length" />
      </div>
    </v-card>

    <v-dialog v-model="dialogSync" persistent max-width="800">
      <v-card class="pa-6">
        <div class="d-flex justify-center">
          <svg-icon icon="clock-master" class="succ-featured pa-10" width="300" height="250" />
        </div>
        <v-card-title class="d-flex justify-center">
          <v-progress-linear indeterminate color="secondary" class="mb-0" />
        </v-card-title>
        <v-card-title class="headline d-flex justify-center assignment-content">{{ $t('content.dialog_school_title_v1') }}</v-card-title>
        <v-card-text class="d-flex justify-center">{{ $t('content.modal_progress_erapor') }}</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Generate -->
    <v-dialog v-model="dialogGenerate" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('confirmation') }}</v-card-title>
        <v-card-text>{{ $t('confirmation_generate_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogGenerate = false">{{ $t('disagree') }}</v-btn>
          <v-btn text @click="synSchool">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="d-flex justify-end align-center mt-5">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import FileViewer from '@/components/FileViewerErapor';

export default {
  name: 'ViewStudentGenerator',
  components: {
    BaseTitle,
    NoData,
    FileViewer
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    },
    isType: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    dataClass: '',
    listStudent: [],
    loadingLoad: false,
    loadingPublish: false,
    titleData: '',
    search: '',
    form: {
      integrationName: '',
      eraporTemplateId: '',
      classroomId: '',
      fullName: '',
      schoolName: '',
      attendances: [],
      courses: [],
      editable: ''
    },
    dialogSync: false,
    dialogPreview: false,
    preview: {},
    published: '',
    dialogGenerate: false
  }),
  methods: {
    getDataDetail() {
      this.$store.dispatch('TemplateErapor/fetchDetailIntegartion', this.$route.params.id).then(ras => {
        Object.keys(this.form).forEach(form => {
          this.form[form] = ras[form];
        });
      });
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('TemplateErapor/fetchListStudent', { eraporIntegrationTemplateId: this.$route.params.id, search: this.search })
        .then(res => {
          this.listStudent = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    getPublish() {
      this.loadingPublish = true;
      this.$store
        .dispatch('TemplateErapor/checkPublish', { eraporIntegrationTemplateId: this.$route.params.id })
        .then(res => {
          this.published = res.published && this.listStudent.length;
        })
        .finally(() => (this.loadingPublish = false));
    },
    publishExport() {
      this.loadingPublish = true;
      const payload = { eraporIntegrationTemplateId: this.$route.params.id, published: this.published ? false : true };

      this.$store
        .dispatch(`TemplateErapor/templatePublish`, payload)
        .then(data => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getPublish();
        })
        .finally(() => (this.loadingPublish = false));
    },
    getExport(id, item) {
      this.loadingLoad = true;
      this.$store
        .dispatch('TemplateErapor/exportDataTemplate', { eraporIntegrationTemplateId: this.$route.params.id, studentId: id })
        .then(res => {
          var blobURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          const fileList = {
            URL: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            extension: 'pdf',
            fileName: `${this.form.integrationName} ${item.fullName} erapor`,
            fileUrl: blobURL,
            key: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            name: `${this.form.integrationName} ${item.fullName} erapor.pdf`,
            size: '186 KB',
            dataUpload: res.data
          };
          this.dialogPreview = true;
          this.$set(this, 'preview', fileList);
        })
        .finally(() => (this.loadingLoad = false));
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    clickGenerate() {
      this.dialogGenerate = true;
    },
    synSchool() {
      this.dialogSync = true;
      this.$store
        .dispatch('TemplateErapor/generateTemplate', this.$route.params.id)
        .then(res => (this.listStudent = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.dialogSync = false;
          this.getData();
          this.dialogGenerate = false;
        });
    },
    editItem(studentId) {
      this.$router.push({ name: 'eRaporGeneratorEdit', params: { studentId } });
    },
    viewItem(studentId) {
      this.$router.push({ name: 'eRaporGeneratorViewStudent', params: { studentId } });
    },
    back() {
      this.$router.push({ name: 'eRaporGeneratorIndex' });
    }
  },
  created() {
    this.getData();
    this.getDataDetail();
    this.getPublish();
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}
</style>
